<template :key="offer">
  <div>
    <div v-if="!iframe && loadIframe">
      <div class="sc-checkoutframe-overlay">
        <iframe :id="`frame-${scOfferWidgetKey}`" class="sc-checkoutframe" :class="{
          open: showPopUp,
        }" :style="`z-index:${highestZIndex + 3}`" :ref-origin="refUrl" :src="iFrameSrc" />
      </div>

      <transition leave-class="fadeOut">
        <template>

          <div v-if="showPayMethods == 'true'">
            <div :class="['sc-pay-method-container-class']">
              <a :id="'card_' + buttonIdText" :class="['sc-pay-method-credit-card']" href="javascript:" @click="show(0)">
                <template v-if="linkImageCard && linkImageCard.length">
                  <img :src="linkImageCard" alt="Pay with Credit Card" />
                </template>
                <template v-else> Pay with Credit Card </template>
              </a>
              <a :id="'paypal_' + buttonIdText" :class="['sc-pay-method-paypal']" href="javascript:" @click="show(1)">
                <template v-if="linkImagePaypal && linkImagePaypal.length">
                  <img :src="linkImagePaypal" alt="Pay with Paypal" />
                </template>
                <template v-else> Pay with Paypal </template>
              </a>
            </div>
          </div>
          <div v-else>
            <a v-if="hasSlotContent" class="no-style" :id="buttonIdText" href="javascript:" @click="show(0)">
                <slot></slot>
            </a>
            <a :id="buttonIdText" v-else-if="type == 'link'" :class="[actionClassText]" href="javascript:"
              @click="show(0)">{{
                linkText || buttonText }}
              {{ withPrice ? `$${defaultPrice}` : "" }}</a>
            <button v-else :id="buttonIdText" :class="[actionClassText]" type="button" @click="show(0)">
              {{ buttonText || linkText }}
              {{ withPrice ? `$${defaultPrice}` : "" }}
            </button>
          </div>
        </template>
      </transition>

      <transition enter-class="fadeIn" leave-class="fadeOut">
        <div v-show="isLoading" class="sc-loading-container" :style="`z-index:${highestZIndex + 3}`">
          <div class="loader">
            <img :src="`${scBaseUrl}/assets/images/icons/preloadder.gif`" alt="Loading..." />
          </div>
        </div>
      </transition>
    </div>
    <div v-else-if="scOfferData" :id="`sc-contain-${scOfferWidgetKey}`">
      <transition leave-class="fadeOut">
        <template v-if="!showPopUp && !iframe">
          <div v-if="showPayMethods == 'true'">
            <div :class="['sc-pay-method-container-class']">
              <a :id="'card_' + buttonIdText" :class="['sc-pay-method-credit-card']" href="javascript:" @click="show(0)">
                <template v-if="linkImageCard && linkImageCard.length">
                  <img :src="linkImageCard" alt="Pay with Credit Card" />
                </template>
                <template v-else> Pay with Credit Card </template>
              </a>
              <a :id="'paypal_' + buttonIdText" :class="['sc-pay-method-paypal']" href="javascript:" @click="show(1)">
                <template v-if="linkImagePaypal && linkImagePaypal.length">
                  <img :src="linkImagePaypal" alt="Pay with Paypal" />
                </template>
                <template v-else> Pay with Paypal </template>
              </a>
            </div>
          </div>
          <div v-else>
            <a v-if="hasSlotContent" class="no-style" :id="buttonIdText" href="javascript:" @click="show(0)">
              <slot></slot>
            </a>
            <a :id="buttonIdText" v-else-if="type == 'link'" :class="[actionClassText]" href="javascript:"
              @click="show(0)">{{
                linkText || buttonText }}
              {{ withPrice ? `$${defaultPrice}` : "" }}</a>
            <button v-else :id="buttonIdText" :class="[actionClassText]" type="button" @click="show(0)">
              {{ buttonText || linkText }}
              {{ withPrice ? `$${defaultPrice}` : "" }}
            </button>
          </div>
        </template>
      </transition>
      <transition enter-class="fadeIn" leave-class="fadeOutBottom">
        <CheckoutForm :offer="scOfferData" :show="showPopUp" v-show="showPopUp" :dcode="dcode" :user-id="userId"
          :username="username" :email="email.replace(/ /g, '+')" :user-type="userType" :widget-key="scOfferWidgetKey"
          :offer-option="offerOption" :pay-method="pay_method" :hostname="hostname" :no-redirect="noRedirect"
          :redirect-url="redirectUrl" :callback-url="callbackUrl" @close="hide" @loader="showLoader"
          :class="[containerClass]" :iframe="iframe" :form-ref="checkout_form_ref" :parent="parent" 
          :license-key="licenseKey"
          />
      </transition>
      <transition enter-class="fadeIn" leave-class="fadeOut">
        <div v-show="isLoading && showPopUp" class="sc-loading-container" :style="`z-index:${highestZIndex + 3}`">
          <div class="loader">
            <img :src="`${scBaseUrl}/assets/images/icons/preloadder.gif`" alt="Loading..." />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CheckoutForm from "./CheckoutFormComponent";
// import Cleave from "cleave.js";

export default {
  components: {
    CheckoutForm,
  },
  props: {
    offer: { type: String, required: true },
    parent: { type: String, required: false, default: "" },
    type: {
      type: String,
      default: "button", //button or link
    },
    buttonText: {
      type: String,
      default: "Buy Now",
    },
    buttonId: {
      type: String,
      default: "",
    },
    showPrice: {
      type: String,
      default: "false",
    },
    linkText: {
      type: String,
      default: "Buy Now",
    },
    linkImageBuy: {
      type: String,
      value: "",
    },
    linkImageCard: {
      type: String,
      value: "",
    },
    linkImagePaypal: {
      type: String,
      value: "",
    },
    showPayMethods: {
      type: String,
      default: "false",
    },
    actionClass: {
      type: String,
      required: false,
    },
    containerClass: {
      type: String,
      required: false,
    },
    onLoad: {
      type: String,
      default: "hide",
    },
    dcode: {
      type: String,
      default: "",
    },
    offerOption: {
      type: String,
      default: "",
    },
    licenseKey: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    userId: {
      type: String,
      default: "",
    },
    username: {
      type: String,
      default: "",
    },
    userType: {
      type: [String, Number],
      default: "",
    },
    iframe: {
      type: [String, Number],
      default: 0,
    },
    user: {
      type: [Array, Object],
      default: () => { },
    },
    payMethod: {
      type: [Number, String],
      default: 0,
    },
    hostname: {
      type: String,
      default: "",
    },
    noRedirect: {
      type: String,
      default: "false",
    },
    redirectUrl: {
      type: String,
      default: "",
    },
    callbackUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      isReady: false,
      scOfferWidgetKey: Math.floor(Math.random() * 16) + 1,
      scOfferData: "",
      showPopUp: false,
      loadIframe: false,
      parentPosition: "",
      parentPositionSecond: "",
      refUrl: window.location.href,
      pay_method: this.payMethod,
      checkout_form_ref: "",
    };
  },
  computed: {
    iFrameSrc() {
      let url = `${this.scBaseUrl}/embed/checkout-frame/${this.offer}?`;
      let props = this.$props;
      for (const prop in props) {
        if (Object.hasOwnProperty.call(props, prop)) {
          if (prop == "payMethod") {
            url += `payMethod=${this.pay_method}&`;
          } else if (prop == "hostname") {
            url += `hostname=${window.location.hostname}&`;
          } else {
            const propValue = props[prop];
            if (propValue || propValue == 0) {
              url += `${prop}=${encodeURI(propValue).replaceAll(
                "&",
                "~AND~"
              )}&`;
            }
          }
        }
      }
      return url;
    },
    withPrice() {
      return ["show", "true", "1"].includes(this.showPrice);
    },
    defaultProductOption() {
      if (this.offerOption) {
        let options = this.scOfferData.options.filter((obj) => {
          return obj.secret == this.offerOption;
        });
        if (options.length) {
          return options[0];
        }
      }
      return this.scOfferData.options.reduce(function (res, obj) {
        return parseFloat(obj.price) < parseFloat(res.price) ? obj : res;
      });
    },
    defaultPrice() {
      return parseFloat(this.defaultProductOption.price) || 0;
    },
    buttonIdText() {
      if (this.buttonId && this.buttonId.length) {
        return this.buttonId;
      }
      return this.checkout_form_ref;
    },
    actionClassText() {
      if (this.actionClass && this.actionClass.length) {
        return this.actionClass;
      }
      if (this.type == "link") {
        return "sc-button-link";
      }
      return "sc-button";
    },
    hasSlotContent() {
      // Check if there is content in the default slot and length is greater than 0 after trimming
      if(!this.$slots.default){
        return false;
      }
      if(Array.isArray(this.$slots.default)){
        return this.$slots.default.filter((slot) => slot.tag !== 'SCRIPT').length > 0;
      }
      return !!this.$slots.default;
    },
  },
  watch: {
    isReady() {
      if (this.isReady) {
        const readyEvent = new Event("ready_" + this.offer);
        // Dispatch the event.
        document.dispatchEvent(readyEvent);

        // Listen for the event.
        document.addEventListener(
          "open_" + this.offer,
          (e) => {
            this.show();
          },
          false
        );
      }
    },
    showPopUp() {
      this.$nextTick(() => {
        if (this.isReady && this.showPopUp) {
          this.pay_method = this.payMethod;
          let viewport = document.head.querySelector('meta[name="viewport"]');
          if (!viewport) {
            var meta = document.createElement("meta");
            meta.setAttribute("name", "viewport");
            meta.setAttribute("content", "width=device-width, initial-scale=1");
            document.getElementsByTagName("head")[0].appendChild(meta);
          } else {
            viewport.setAttribute(
              "content",
              "width=device-width, initial-scale=1"
            );
          }
          // new Cleave("#credit_card_number", {
          //   creditCard: true,
          //   creditCardStrictMode: false,
          //   delimiter: "-",
          // });

          // new Cleave("#credit_card_expiry", {
          //   date: true,
          //   datePattern: ["m", "y"],
          // });

          // new Cleave("#credit_card_cvc", {
          //   numeral: true,
          //   numeralPositiveOnly: true,
          //   numericOnly: true,
          // });
        }
        if (!this.showPopUp) {
          if (scViewport) {
            let viewport = document.head.querySelector('meta[name="viewport"]');
            viewport.setAttribute("content", scViewport);
          } else {
            document.head.querySelector('meta[name="viewport"]').remove();
          }
        }
      });
    },
  },
  created() {
    this.getOffer();
    this.loadCss();
    this.makeId();
    window.addEventListener("message", this.handleSellcodesSuccessEvent, false);
    this.isLoading = false;
  },

  methods: {
    handleSellcodesSuccessEvent(event) {
      if (event.data == "sellcodesClose") {
        this.closeIframe();
      }
      if (event.data == "sellcodesLoaderShow") {
        this.isLoading = true;
      }
      if (event.data == "sellcodesLoaderHide") {
        this.isLoading = false;
      }
    },
    loadCss() {
      let cssId = "scCheckoutCss";
      if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName("head")[0];
        var link = document.createElement("link");
        link.id = cssId;
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = this.scBaseUrl + "/quick-checkout/css/quick-checkout.min.css";
        // link.href = this.scBaseUrl + "/quick-checkout/css/quick-checkout.css";
        link.media = "all";
        head.appendChild(link);
      }
    },
    getOffer() {
      if (window.top) {
        window.top.postMessage("sellcodesLoaderShow", "*");
      }
      this.isLoading = true;

      scAxios
        .get(`embed/offers/${this.offer}/details`)
        .then((result) => {
          this.scOfferData = result.data;
          this.isLoading = false;
          if (window.top) {
            window.top.postMessage("sellcodesLoaderHide", "*");
          }
          this.isReady = true;
          if (this.onLoad == "show") {
            this.show();
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          window.top.postMessage("sellcodesLoaderHide", "*");
        });
    },
    show(pay_method = 0) {
      this.pay_method = pay_method;
      this.showForm();
      this.isLoading = false;
    },
    showForm() {
      if (!this.isSelfHosted) {
        this.loadIframe = true;
        this.isLoading = true;
      } else {
        this.showPopUp = true;
        document
          .getElementsByTagName("body")[0]
          .classList.toggle("sellcodes-overlay");

        if (!this.isSelfHosted) {
          document
            .getElementsByTagName("body")[0]
            .classList.toggle("sellcodes-overlay-iframe");
        }

        let parentNode = document.getElementById(
          `sc-contain-${this.scOfferWidgetKey}`
        );
        if (parentNode) {
          parentNode = parentNode.parentNode.parentNode;

          if (!this.parentPosition) {
            this.parentPosition = this.getPosition(parentNode);
          }
          parentNode.style.setProperty("position", "relative", "important");
        }

        let parentNodeSecond = document.getElementById(
          `sc-contain-${this.scOfferWidgetKey}`
        );
        if (parentNodeSecond) {
          parentNodeSecond = parentNodeSecond.parentNode.parentNode.parentNode;
          if (!this.parentPositionSecond) {
            this.parentPositionSecond = this.getPosition(parentNodeSecond);
          }
          parentNodeSecond.style.setProperty(
            "position",
            "relative",
            "important"
          );
        }
      }
    },
    hide() {
      if (window.top && this.showPopUp) {
        window.top.postMessage("sellcodesClose", "*");
        window.top.postMessage("sellcodesLoaderHide", "*");
        this.loadIframe = false;
      }
      this.showPopUp = false;
      if (this.isSelfHosted) {
        document
          .getElementsByTagName("body")[0]
          .classList.toggle("sellcodes-overlay");
        document
          .getElementsByTagName("body")[0]
          .classList.toggle("sellcodes-overlay-iframe");
        let parentNode = document.getElementById(
          `sc-contain-${this.scOfferWidgetKey}`
        ).parentNode.parentNode;
        let parentNodeSecond = document.getElementById(
          `sc-contain-${this.scOfferWidgetKey}`
        ).parentNode.parentNode.parentNode;
        parentNode.style.position = this.parentPosition;
        parentNodeSecond.style.position = this.parentPositionSecond;
      }
    },
    closeIframe() {
      this.loadIframe = false;
      this.showPopUp = false;
    },
    showLoader(type) {
      this.isLoading = type;
    },
    makeId(length = 10) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      this.checkout_form_ref = result;
    },
    getPosition(elem) {
      if (!elem) return []; // Element does not exist, empty list.
      var win = document.defaultView || window,
        style,
        styleNode = "";
      if (win.getComputedStyle) {
        /* Modern browsers */
        style = win.getComputedStyle(elem, "");
        return style.position;
      } else if (elem.currentStyle) {
        /* IE */
        style = elem.currentStyle;
        return style.position;
      } else {
        /* Ancient browser..*/
        style = elem.style;
        return style.position;
      }
      return styleNode;
    },
  },
};
</script>



// WEBPACK FOOTER //
// CheckoutButtonsComponent.vue?05966d54